import styled from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const OverviewContainer = styled.div`
  ${breakpoint("tablet")`
    display: flex;
    gap: 32px;
  `}
`

export const IntroVideoContainer = styled.div`
  padding: 32px 0;

  ${breakpoint("tablet")`
    flex: 0 0 25%;
    display: flex;
    justify-content: end;
    padding-right: 0;
    padding-top: 0;
  `}
`
export const IntroVideo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #333;
  border-radius: 16px;
  color: #fff;
  font-size: 1.5rem;
  text-align: center;
  line-height: 1.7em;
  aspect-ratio: 9/19;
  width: 50vw;
  margin: 0 auto;

  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;

  ${breakpoint("tablet")`
    ${({ width }) => (width ? `width: ${width}px` : `width: unset;`)};
    ${({ height }) => (height ? `height: ${height}px` : `height: 50%; height: 50vh;`)};
    max-height: 500px;
    margin: 0;
  `}
`
export const Label = styled.p`
  position: absolute;
  margin-top: 7rem;
  font-size: 1rem;
`
